module.exports = __webpack_public_path__ + "static/media/birthday-cake.fcb058ef.svg";